<template>
  <v-row>
    <v-col
      cols="12"
      class="pt-2 pb-0"
      v-if="updateMeetingPermission || generateTranscriptionPermission"
    >
      <h4>{{ $t("agenda.lblInformationGatheringProcess") }}</h4>
    </v-col>
    <v-col cols="12" sm="12">
      <v-tooltip bottom v-if="updateMeetingPermission">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            v-if="updateMeetingPermission"
            color="primaryDark mr-2"
            @click.stop="attributeInfo()"
          >
            {{ $t("agenda.lblGenerateAttributeInfo") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblGenerateAttributeInfo") }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="generateTranscriptionPermission">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="generateTranscriptionPermission"
            v-bind="attrs"
            v-on="on"
            color="primaryDark mr-2"
            @click.stop="transcription()"
          >
            {{ $t("agenda.lblGenerateTranscription") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblGenerateTranscription") }}</span>
      </v-tooltip>
    </v-col>
    <!-- <v-col cols="12">
      <v-divider></v-divider>
    </v-col> -->
    <generate-attribute
      v-if="attributeInfoDialog && updateMeetingPermission"
      v-model="attributeInfoDialog"
      :categorizedTopics="categorizedTopics"
      :meetingObject="meetingObject"
    ></generate-attribute>
    <generate-transcription
      v-if="transcriptionDialog && generateTranscriptionPermission"
      v-model="transcriptionDialog"
      :meetingObject="meetingObject"
    ></generate-transcription>
    <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import GenerateAttribute from "@/components/GenerateAttribute.vue";
import GenerateTranscription from "@/components/GenerateTranscription.vue";
import Loader from "@/components/Loader.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
export default {
  name: "MomGenerate",
  mixins: [SignalRMixin],
  components: {
    GenerateAttribute,
    GenerateTranscription,
    Loader,
  },
  props: {
    categorizedTopics: {
      type: Array,
      default: () => [],
    },
    meetingObject: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      attributeInfoDialog: false,
      transcriptionDialog: false,
      Loaderloading: false,
    };
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
    generateTranscriptionPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "GenerateTranscription"
        );
      }
      return false;
    },
  },
  async mounted() {
    const targetVotingTopic = "meeting_voting_" + this.meetingObject.id;
    await this.signalRTopicVoting(targetVotingTopic);
    const targetAdminPermission = "admin_" + this.selectedTenant;
    await this.signalRAdminPermission(targetAdminPermission);
    const attendanceNoteTarget = `attendance_note_${this.meetingObject.id}`;
    await this.signalRAttendanceNote(attendanceNoteTarget);
  },
  methods: {
    ...mapActions({
      getMeetingVotersSummary: "meeting/getMeetingVotersSummary",
    }),
    async signalRAttendanceNote(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          if (
            res?.attendees &&
            Array.isArray(res.attendees) &&
            this.meetingObject?.attendees &&
            Array.isArray(this.meetingObject.attendees)
          ) {
            const updatedAttendees = this.meetingObject.attendees.map((attendee) => {
              const updated = res.attendees.find(a => a.id === attendee.id);
              if (updated) {
                return {
                  ...attendee,
                  attendeNote: updated.attendeNote ?? attendee.attendeNote,
                  attendedState: updated.attendedState ?? attendee.attendedState,
                };
              }
              return attendee;
            });

            this.$set(this.meetingObject, 'attendees', updatedAttendees);
          }
        });
        
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        console.error('SignalR attendance note error:', error);
      }
    },
    async attributeInfo() {
      await this.getMeetingVotersSummary(this.meetingObject.id);
      this.attributeInfoDialog = true;
    },
    transcription() {
      this.transcriptionDialog = true;
    },
    signalRTopicVoting,
    signalRAdminPermission
  },
};

async function signalRTopicVoting(target) {
  this.signalConnection.on(target, async (message) => {
    if (this.votingRightPermission || this.auditorConsentPermission) {
      if (this.updateMeetingPermission && this.attributeInfoDialog) {
        await this.getMeetingVotersSummary(this.meetingObject.id);
      }
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function signalRAdminPermission(target) {
  try {
    this.signalConnection.on(target, async (message) => {
      if (this.updateMeetingPermission && this.attributeInfoDialog) {
        await this.getMeetingVotersSummary(this.meetingObject.id);
      }
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {
    console.log(error, "api error");
  }
}
</script>